import { useMemo, useState } from 'react'
import { adminUpdateUserTransaction } from '@/actions/admin/transactionActions'
import { Transaction } from '@/reducers/admin/allTransactions.slice'
import { Button, Dialog, Text } from '@/ui'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'

export const useToggleTransactionConfirmed = ({
  transaction,
  onUpdated = () => undefined,
}: {
  transaction: Transaction
  onUpdated?: () => void
}) => {
  const dispatch = useAppDispatch()
  const [isUpdating, setUpdating] = useState(false)
  const [open, setOpen] = useState(false)

  const unconfirming = useMemo(
    () => Boolean(transaction.confirmedAt),
    [transaction]
  )
  const ineligible = useMemo(
    () =>
      !transaction.type ||
      (transaction.type === 'business' && !transaction.transactionCategoryId),
    [transaction]
  )

  const acceptTransaction = async (confirmed: boolean) => {
    const confirmedAt = confirmed ? Date.now() : null
    setUpdating(true)
    const data = {
      confirmedAt,
      requestedClarificationAt: null,
      notifiedRequestedClarificationAt: null,
    }

    await adminUpdateUserTransaction(transaction.id, data)(dispatch)
    setUpdating(false)
    onUpdated()
  }

  const renderModal = () => (
    <Dialog onClose={() => setOpen(false)} open={open}>
      <Dialog.Content>
        <Dialog.Title>
          {unconfirming ? 'Unconfirm ' : 'Confirm '} Transaction
        </Dialog.Title>
        <Text variant={TypographyStyles.BODY_SM} className="my-2">
          Are you sure you want to {unconfirming ? 'unconfirm' : 'confirm'} this
          transaction? This action creates new journal entries.
        </Text>

        <Dialog.Footer>
          <Button
            onClick={() => setOpen(false)}
            variant="link"
            style={{ marginRight: 36 }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              acceptTransaction(!unconfirming)
              setOpen(false)
            }}
          >
            {unconfirming ? 'Unconfirm' : 'Confirm'}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
  return {
    renderModal,
    openModal: () => setOpen(true),
    isUpdating,
    unconfirming,
    ineligible,
  }
}
